







import { Component, Vue } from 'vue-property-decorator';
import baguetteBox from './Lightbox.lib';
import { randomId } from '@/common/bot/lib';

@Component
export default class LightBox extends Vue {
  generatedId!: string

  get selector () {
    return `div[data-baguette-box="${this.generatedId}"]`;
  }

  created () {
    this.generatedId = `${randomId(10)}-${randomId(10)}-image`;
  }

  mounted () {
    baguetteBox.run(this.selector, {
      noScrollbars: true,
      filter: /^(blob:[^'"]+|[^\s]+\.(jpe?g|png))$/i,
    });
  }

  beforeDestroy () {
    baguetteBox.destroyOne(this.selector);
  }
}
